import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, type HTMLAttributes } from 'vue';
import { DialogDescription, type DialogDescriptionProps } from 'reka-ui';
import { cn } from '@/lib/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'DialogDescription',
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(__props: any) {

const props = __props;
const forwarded = computed(() => {
  const { class: _class, ...rest } = props;
  return rest;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogDescription), _mergeProps(forwarded.value, {
    class: _unref(cn)('text-sm leading-relaxed text-muted-foreground', props.class)
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})